import React from 'react'
import IconFacebook from '../icons/IconFacebook'
import IconTwitter from '../icons/IconTwitter'
import IconInstagram from '../icons/IconInstagram'

const Social = () => {
    return (
        <ul className="social">
            <li>
                <a href="https://www.facebook.com/SpringsHotelPeru" rel="noopener noreferrer" target="_blank">
                    <IconFacebook color='#FFFFFF' height='16px' />
                </a>
            </li>
            <li>
                <a href="https://twitter.com/PeruSpring" rel="noopener noreferrer" target="_blank">
                    <IconTwitter color='#FFFFFF' height='16px' />
                </a>
            </li>
            <li>
                <a href="https://www.instagram.com/SpringsHotelPeru/" rel="noopener noreferrer" target="_blank">
                    <IconInstagram color='#FFFFFF' height='16px' />
                </a>
            </li>
        </ul>
    )
}

export default Social